export const API_URL = "https://web-api.viyume.com/mail/send-mail-calmee";
export const RECAPTCHA_KEY = "6LdN2ZorAAAAAAakncggrPIhbEic3i_qa5bxzPbi";